// Centralizes token retrieval and updates
class TokenManager {
    constructor() {
        this.currentToken = null;
        this.msalInstance = null;
        this.accounts = null;
    }

    /**
     * Initialize with MSAL instance and accounts
     */
    initialize(msalInstance, accounts) {
        this.msalInstance = msalInstance;
        this.accounts = accounts;
    }

    /**
     * Get current valid token
     * Returns cached token or fetches from MSAL if not available
     */
    async getToken() {
        // return current token if present
        if (this.currentToken) {
            return this.currentToken;
        }

        // fetch from MSAL
        if (!this.accounts || this.accounts.length === 0) {
            throw new Error("No MSAL accounts available");
        }

        const activeAccount = this.accounts[0];

        // Try in-memory token first
        if (activeAccount.idToken) {
            this.currentToken = activeAccount.idToken;
            return this.currentToken;
        }

        // Fall back to acquireTokenSilent
        try {
            const request = {
                scopes: ["openid", "profile"],
                account: activeAccount
            };

            const response = await this.msalInstance.acquireTokenSilent(request);
            this.currentToken = response.idToken;
            return this.currentToken;
        } catch (error) {
            console.error('Failed to get token:', error);
            throw error;
        }
    }

    updateToken(newToken) {
        console.log('Token updated in TokenManager');
        this.currentToken = newToken;
    }

    // Clear the current token
    clearToken() {
        this.currentToken = null;
    }

    // Check if token is initialized
    hasToken() {
        return this.currentToken !== null;
    }
}

// Export singleton instance
export const tokenManager = new TokenManager();